import { Button, Checkbox, Modal } from 'antd';

export const CulumnSettings = ({
  isSettingsOpen,
  toggleSettings,
  toggleColumnVisibility,
  moveColumn,
  saveColumns,
  columnsOrder,
}) => {
  return (
    <Modal open={isSettingsOpen} onCancel={toggleSettings} onOk={saveColumns} title="Column Setting">
      <p>Customize the columns displayed in the table.</p>
      {columnsOrder.map((col, idx) => (
        <div key={col.id} style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
          <span style={{ flex: 1 }}>{col.label}</span>
          <Checkbox checked={!col.hidden} onChange={() => toggleColumnVisibility(idx)} style={{ marginRight: 8 }}>
            Show
          </Checkbox>
          <Button size="small" style={{ marginRight: 4 }} disabled={idx === 0} onClick={() => moveColumn(idx, -1)}>
            Up
          </Button>
          <Button size="small" disabled={idx === columnsOrder.length - 1} onClick={() => moveColumn(idx, 1)}>
            Down
          </Button>
        </div>
      ))}
    </Modal>
  );
};
